import React from 'react';
import { TourProvider } from '@reactour/tour';
import Alerts from '../components/alert';
import VersioningAlert from '../components/alert/versioning';
import Footer from '../components/footer';
import ModalManager from '../components/modal/ModalManager';
import useLoadAmplitude from '../hooks/useLoadAmplitude';
import Routes from '../routes/routes';
import { initializeSentry } from '../utilities/sentry';
import { LayoutProvider } from './LayoutContext';
import Navbar from './dashboard/components/navigation/navbar/Navbar';
import TourContent from './dashboard/components/onboarding/tour/TourContent';
initializeSentry();
var App = function() {
    useLoadAmplitude();
    return /*#__PURE__*/ React.createElement(TourProvider, {
        steps: [],
        ContentComponent: TourContent,
        onClickMask: function() {}
    }, /*#__PURE__*/ React.createElement(LayoutProvider, null, /*#__PURE__*/ React.createElement("div", {
        className: "App"
    }, /*#__PURE__*/ React.createElement(Navbar, null), /*#__PURE__*/ React.createElement("div", {
        className: "alert-container text-center w-100"
    }, /*#__PURE__*/ React.createElement(VersioningAlert, null), /*#__PURE__*/ React.createElement(Alerts, null)), /*#__PURE__*/ React.createElement(Routes, null), /*#__PURE__*/ React.createElement(Footer, null), /*#__PURE__*/ React.createElement(ModalManager, null))));
};
export default App;
